import { AxiosRequestConfig } from "axios";
import http from "./HttpClient";
import { useStoreBase } from "../../store";

const post = (
  url: string,
  payload: Object,
  config: AxiosRequestConfig<any> = {}
) =>
  http
    .post(url, payload, config)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => {
      console.error("[API error]", error);
      useStoreBase.setState({
        notification: {
          message:
            typeof error.response?.data?.detail === "string"
              ? error.response.data.detail
              : !error.response
              ? "Интернэт холболтоо шалгаад дахин оролдоно уу."
              : "Серверийн алдаа гарлаа. Түр хүлээгээд дахин оролдоно уу.",
          type: "error",
        },
      });
    });

const BaseService = {
  post,
};

export default BaseService;
